import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Glossary } from '../models/glossary';

@Injectable({
  providedIn: 'root'
})
export class GlossaryService {

apiUrl = 'https://data2.ifa.com/'

constructor(private http: HttpClient) { }

getGlossary() : Observable<Glossary[]> {
  let url = `${this.apiUrl}odata/v1/glossary/`
  return this.http.get<Glossary[]> (url)
}

}
